/** Класс роботы с избраным */
window.k1ChosenGoods = {

	/**
	 * Получение текещего элемениа
	 * @param event
	 * @returns {{scu: string, name: string, id: string, picture: string, element: *}}
	 */
	getProduct: function (event) {
		let prodpsSCU = '';
		// Small card
		if (event.target.closest('.good-item__hover')){
			if (event.target.closest('.good-item__hover').querySelector('.product-item-scu-item-text-container.selected'))
				prodpsSCU = event.target.closest('.good-item__hover').querySelector('.k1-sku-list-js.good-item__sku-list').getAttribute('data-scu')
		}

		// Detail  page
		if (event.target.closest('.good-element__info')){
			if (event.target.closest('.good-element__info').querySelector('.k1-sku-block-js.good-item__sku-block'))
				prodpsSCU = event.target.closest('.good-element__info').querySelector('.k1-sku-block-js.good-item__sku-block').getAttribute('data-current-sku')
		}

		return {
			id: event.target.closest('.k1-favorite-js').getAttribute('data-product-id'),
			element: event.target.closest('.k1-favorite-js'),
			picture: event.target.closest('.k1-favorite-js').getAttribute('data-product-picture'),
			name: event.target.closest('.k1-favorite-js').getAttribute('data-product-name'),
			scu:  prodpsSCU
		};
	},

	/**
	 * Получение имени cookie
	 * @param name
	 * @returns {any}
	 */
	getCookieIds: function (name) {
		return window.k1Cookies.getCookie(name);
	},

	/**
	 * Получение даты cookie
	 * @returns {Date}
	 */
	setCookieLife: function () {
		let limitDate = new Date();
		const months = 3;
		limitDate.setMonth(limitDate.getMonth() + months);
		return limitDate
	},

	/**
	 * Проверка элемента в обьекте и выбор метода
	 * @param product
	 * @param name
	 */
	checkProductInArray: function (product, name) {
		let items = JSON.parse(this.getCookieIds(name));
		if ( product.id in items ) {
			this.deleteProduct(items, product, name);
		} else {
			this.addProduct(items, product, name);
		}

	},

	/**
	 * Добавление в cookie
	 * @param arr
	 * @param product
	 * @param name
	 */
	addProduct: function (arr, product, name) {
		arr[product.id] = product.scu;
		window.k1Cookies.setCookie(name, JSON.stringify(arr), { path: '/', expires: new Date(this.setCookieLife()) });
		product.element.classList.add('k1-in-favorite');

		this.setHeaderCount(arr);
		document.querySelector('.k1-header-favorite-count-js').classList.add('header__tools-count--show');

		let propsTitle = product.name;
		if (product.element.closest('.good-item__hover')) {
			if (product.element.closest('.good-item__hover').querySelector('.product-item-info-container:not(.hidden) .product-item-scu-item-text-container.selected'))
				propsTitle = product.name + ' ('+ product.element.closest('.good-item__hover').querySelector('.product-item-info-container:not(.hidden) .product-item-scu-item-text-container.selected').getAttribute('title') + ')';
		}

		if (product.element.closest('.good-element__info')) {
			if( document.querySelector('.scu-multi') !== null ) {
				propsTitle = product.name + ' (' + document.querySelector('.product-item-detail-info-container[data-type="RAZMER_KROVATI"] .product-item-scu-item-text-container.selected').getAttribute('title') + ')';
			}
			else
				propsTitle = product.name + ' ('+ product.element.closest('.good-element__info').querySelector('.product-item-scu-item-text-container.selected').getAttribute('title') + ')';

			// if (product.element.closest('.good-element__info').querySelector('.product-item-scu-item-text-container.selected'))
		}

		window.k1Action.showAddedModal(
			window.k1Action.getElements(),
			product.picture,
			propsTitle,
			this.setHeaderCount(arr),
			'/izbrannoe/',
			'Избранное',
			'избранное'
		)
	},

	/**
	 * Удаление из cookie
	 * @param arr
	 * @param product
	 * @param name
	 */
	deleteProduct: function (arr, product, name) {
		delete arr[product.id]
		window.k1Cookies.setCookie(name, JSON.stringify(arr), { path: '/', expires: new Date(this.setCookieLife()) });
		product.element.classList.remove('k1-in-favorite');

		if (!this.setHeaderCount(arr)) {
			document.querySelector('.k1-header-favorite-count-js').classList.remove('header__tools-count--show');
		}
		this.setHeaderCount(arr);

		let hrefPath = location.pathname.split('/');
		if (hrefPath.includes('izbrannoe')) {
			let item = product.element.closest('.good-item');
			item.remove();
			window.k1ScriptCatalog.setLastChildFavorites();

			// if ( this.setHeaderCount(arr) == 0 )
			// 	location.reload()
		}
	},

	/**
	 * Изменение количества элементов
	 * @param arr
	 * @returns {number}
	 */
	setHeaderCount: function (arr) {
		let count = Object.keys(arr).length;
		document.querySelector('.k1-header-favorite-count-js').textContent = count;

		return count;
	},

	init: function () {
	},
};

$('body').on('click', '.k1-favorite-js', function (e) {
	let favorite = e.target.closest('.favorite-page');
	window.k1ChosenGoods.checkProductInArray(window.k1ChosenGoods.getProduct(e), 'k1FavoriteGoods');

	// Page izbrannoe
	if ( favorite != null) {
		let count =  Object.keys(JSON.parse(window.k1Cookies.getCookie('k1FavoriteGoods'))).length;
		if ( count < 1) {
			$('.favorite-page__no-resault').attr('style','');
			$('.favorite-page__row').attr('style','display:none;');
			$('.favorite-page .section-goods__list').attr('style','display:none;');
		}
	}

	return false;
});





/*
window.k1ChosenGoods = {

	getProduct: function (event) {
		return {
			id: event.target.closest('.k1-favorite-js').getAttribute('data-product-id'),
			element: event.target.closest('.k1-favorite-js'),
			picture: event.target.closest('.k1-favorite-js').getAttribute('data-product-picture'),
			name: event.target.closest('.k1-favorite-js').getAttribute('data-product-name'),
			scu: event.target.closest('.good-item__hover').querySelector('.product-item-scu-item-text-container.selected').getAttribute('data-val')
		};
	},

	getCookieIds: function (name) {
		return window.k1Cookies.getCookie(name);
	},

	setCookieLife: function () {
		let limitDate = new Date();
		const months = 3;
		limitDate.setMonth(limitDate.getMonth() + months);
		return limitDate
	},

	checkProductInArray: function (product, name) {
		console.log('product : ', product);
		console.log('name : ', name);

		console.log('getCookieIds : ', this.getCookieIds(name));
		console.log('getCookieIds : ', JSON.parse(this.getCookieIds(name)).length);

		if (!this.getCookieIds(name)) {
			this.addProduct([], product, name)
		}
		if (!JSON.parse(this.getCookieIds(name)).length) {
			this.addProduct([], product, name)
		} else {
			let items = JSON.parse(this.getCookieIds(name));
			if (items.includes(product.id)) {
				this.deleteProduct(items, product, name);
			} else {
				this.addProduct(items, product, name);
			}
		}
	},

	addProduct: function (arr, product, name) {
		arr.push(product.id);

		window.k1Cookies.setCookie(name, JSON.stringify(arr), { path: '/', expires: new Date(this.setCookieLife()) });
		product.element.classList.add('k1-in-favorite');
		this.setHeaderCount(arr.length);
		document.querySelector('.k1-header-favorite-count-js').classList.add('header__tools-count--show');
		let propsTitle = product.element.closest('.good-item__hover').querySelector('.product-item-scu-item-text-container.selected').getAttribute('title')
		window.k1Action.showAddedModal(
			window.k1Action.getElements(),
			product.picture,
			product.name + ' ('+ propsTitle + ')',
			arr.length,
			'/izbrannoe/',
			'Избранное',
			'избранное'
		)
	},

	deleteProduct: function (arr, product, name) {
		arr.splice(arr.indexOf(product.id), 1);
		window.k1Cookies.setCookie(name, JSON.stringify(arr), { path: '/', expires: new Date(this.setCookieLife()) });
		product.element.classList.remove('k1-in-favorite');
		if (!arr.length) {
			document.querySelector('.k1-header-favorite-count-js').classList.remove('header__tools-count--show');
		}
		this.setHeaderCount(arr.length);
		let hrefPath = location.pathname.split('/');
		if (hrefPath.includes('izbrannoe')) {
			let item = product.element.closest('.good-item');
			item.remove();
			window.k1ScriptCatalog.setLastChildFavorites();
		}
	},

	setHeaderCount: function (count) {
		document.querySelector('.k1-header-favorite-count-js').textContent = count;
	},

	init: function () {
	},
};

window.addEventListener('click', e => {
	console.log('Target: ',e.target);
	if (e.target.closest('.k1-favorite-js')) {
		window.k1ChosenGoods.checkProductInArray(window.k1ChosenGoods.getProduct(e), 'k1FavoriteGoods')
	}
});

*/


